import React from 'react'
import { BiLogoWhatsapp } from "react-icons/bi";

function ReleaseNotePage() {
  return (
    <section id="home" className="d-flex align-items-center homePage">
        <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
        <div className="container">
            <div className="row">
            <h3 className="fontColor-1">RELEASE NOTES</h3>
            <div className='bg-white-release-card'>
              <h5 className="fontColor-2">RELEASE NOTE V1.2 (February 23, 2023)</h5>
              <ol className="release-points">
                <li>Uploading trek image, converting it to base64 and save it in db. </li>
                <li>Downloading Participant list to excel sheet.</li>
                <li>Home Page UI improvements.</li>
                <li>Loading animation until API loads.</li>
                <li>Responsive Navigation Bar.</li>
                <li>Footer UI improvements.</li>
                <li>Category Creation - One Day and Two Day Trek.</li>
                <li>New Pages - Gallery, About, Contact.</li>
                <li>WhatsApp button on scroll.</li>
                <li>Form Validation.</li>
                <li>Login Authentication </li>
                <li>New Backend API's</li>
              </ol>
            </div>
            </div>
        </div>
    </section>
  )
}

export default ReleaseNotePage
